// extracted by css-extract-rspack-plugin
var _1 = "LQdu0jXVlPgmeqD8";
var _2 = "en8SYWd6zgUaAZsc";
export { _1 as "input", _2 as "promptInput" }
// extracted by css-extract-rspack-plugin
var _1 = "LQdu0jXVlPgmeqD8";
var _2 = "en8SYWd6zgUaAZsc";
export { _1 as "input", _2 as "promptInput" }
